module.exports = __webpack_public_path__ + "img/wrench.42b255c3.svg";